"use client";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton } from "@mui/material";
import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import usePopOver from "@/hooks/use-popover";
import ISubject from "@/interfaces/subject.interface";
import { SubjectMessages } from "@/messages/subject/subject.messages";

import { SubjectPopover } from "../Popover";

interface Props {
  subject: ISubject;
  messages: SubjectMessages;
  index: number;
}

export function SubjectTableRow({ subject, index, messages }: Props) {
  const { openPopover, anchorEl, closePopover, isOpen, selected } = usePopOver<ISubject>();

  return (
    <TableRow index={index}>
      <TableCell>{subject.id}</TableCell>
      <TableCell>{subject.subject}</TableCell>
      <TableCell>
        <IconButton onClick={(e) => openPopover(e, subject)}>
          <MoreHorizIcon />
        </IconButton>

        {selected && (
          <SubjectPopover
            isOpen={isOpen}
            anchorEl={anchorEl}
            onClose={closePopover}
            messages={messages}
            selected={selected}
          />
        )}
      </TableCell>
    </TableRow>
  );
}
